export default {
    'Close menu': 'Menu sluiten',
    'Close submenu': 'Submenu sluiten',
    'Open submenu': 'Submenu openen',
    'Toggle submenu': 'Submenu wisselen'
};



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/core/screenreader/translations/nl.js
// module id = 104
// module chunks = 0